import {
    createSignal,
    onMount,
    createEffect,
} from 'solid-js'

export const useLikertMoleculeController = (props) => {
    const [
        selectedValue,
        setSelectedValue,
    ] = createSignal(props.defaultValue || null)

    onMount(() => {
        if (props.defaultValue) {
            setSelectedValue(props.defaultValue)
        }
    })

    const handleSelect = (value) => {
        setSelectedValue(value)

        if (props.onChange) {
            props.onChange(value)
        }
    }

    const isSelected = (optionValue) => selectedValue() === optionValue
    const isCircleStyle = () => props.style === 'circle'


    const getIconButtonClasses = (optionValue) => ({
        'likert-molecule__icon-button--circle': isCircleStyle(),
        'likert-molecule__icon-button--emoji': !isCircleStyle(),
        'likert-molecule__icon-button--selected': isSelected(optionValue),
    })

    const getContainerClasses = () => ({
        [props.class]: Boolean(props.class),
    })

    const getIconPath = (option) => {
        if (isCircleStyle()) {
            return isSelected(option.value)
                ? 'icons/radio-selected'
                : 'icons/radio-deselected'
        }

        return option.path
    }

    return {
        getContainerClasses,
        getIconButtonClasses,
        getIconPath,
        handleSelect,
        isCircleStyle,
        isSelected,
        selectedValue,
    }
}